import { observer } from 'mobx-react';
import { Component } from 'react';

import { RequestQuoteActionState } from '../../configurator/components/RequestQuoteAction/RequestQuoteActionState';
import { GetProductConfigurationByCodeQueryResponse, ProductConfigurationOrigin } from '../../data/model';
import ActionButton from '../../shared/components/ActionButton';
import TertiaryButton from '../../shared/components/Button/TertiaryButton';
import { StoreState } from '../../StoreState';
import css from './ConfigurationDetailsActions.css';
import { GoToConfiguratorActionState } from './GoToConfiguratorActionState';

export interface ConfigurationDetailsActionsTranslations {
  requestQuoteButton: string;
  configureButton: string;
}

export interface ConfigurationDetailsActionsState {
  code: string;
  details: GetProductConfigurationByCodeQueryResponse;
  store: StoreState;
  requestQuote: RequestQuoteActionState;
  configure: GoToConfiguratorActionState;
  translation: ConfigurationDetailsActionsTranslations;
}

export interface ConfigurationDetailsActionsProps {
  state: ConfigurationDetailsActionsState;
}

@observer
export default class ConfigurationDetails extends Component<ConfigurationDetailsActionsProps> {
  render() {
    const { store, details, requestQuote, configure, translation } = this.props.state;
    const isDefaultConfiguratorOrigin = details.configuration.origin === ProductConfigurationOrigin.DefaultConfigurator;
    const shouldRender = store.canRequestQuote() || isDefaultConfiguratorOrigin;

    if (!shouldRender) {
      return null;
    }

    return (
      <div className={css.root}>
        {store.canRequestQuote() && (
          <ActionButton className={css.button} command={requestQuote.proceedToRequestQuoteCommand}>
            {translation.requestQuoteButton}
          </ActionButton>
        )}
        {isDefaultConfiguratorOrigin && (
          <ActionButton className={css.button} command={configure.goToConfiguratorCommand} itemElement={TertiaryButton}>
            {translation.configureButton}
          </ActionButton>
        )}
      </div>
    );
  }
}
